import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ProjectFile } from '@portal-core/project-files/models/project-file.model';
import { ProjectFilesService } from '@portal-core/project-files/services/project-files.service';
import { InputObservable } from '@portal-core/util/input-observable.decorator';
import { Base64 } from 'js-base64';
import { Observable, map } from 'rxjs';

@Component({
  selector: 'mc-project-file-gitbar',
  templateUrl: './project-file-gitbar.component.html',
  styleUrls: ['./project-file-gitbar.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProjectFileGitbarComponent implements OnInit {
  @Input() projectFile: ProjectFile;
  @Input() showLineCount: boolean = true;
  @InputObservable('projectFile') projectFile$: Observable<ProjectFile>;

  fileLineCount$: Observable<number>;

  constructor(private projectFilesService: ProjectFilesService) { }

  ngOnInit() {
    this.fileLineCount$ = this.projectFile$.pipe(
      map(projectFile => {
        if (projectFile) {
          return Base64.decode(projectFile.Content);
        }
      }),
      map(content => content && this.showLineCount ? this.projectFilesService.getFileLineCount(content) : 0)
    );
  }
}
